import React, { useState } from "react";

const Accordion = ({title, content}) =>
{
	const [toggle, SetToggle] = useState(false);
	
	return <div className="mb-2 border border-primaryBorder rounded">
		<div className="p-2 flex justify-between cursor-pointer hover:bg-highlightBG" onClick={() => SetToggle(!toggle)}>
			<span className="font-bold">{title}</span>
			<i className="fa fa-chevron-down text-primary"></i>
		</div>
		{toggle && <div className="p-2" dangerouslySetInnerHTML={{__html: content}} />}
	</div>
}

export default Accordion;